<template>
  <div>
    <div v-if="type === 'TEXT' && item.content" class="output" v-html="generate(item.content)" />
    <template v-if="type === 'IMAGE' && item.file">
      <template v-if="item.file.isVideo && item.file.isVideo.video">
        <div class="video">
          <video
            ref="video"
            class="lazy"
            muted
            playsinline
            :loop="item.fileLoop"
            :autoplay="item.fileAutoplay"
            :controls="false"
          >
            <source :data-src="item.file.isVideo.video" type="video/mp4">
            {{ item.fileAlt || 'Video' }}
          </video>
          <div :class="['video-button-container', 'play', { 'hide': playing }]" @click="play">
            <div class="play-button">
              <play-button />
            </div>
          </div>
          <div class="video-button-container pause" @click="pause" />
        </div>
      </template>
      <template v-else-if="item.url">
        <a :href="item.url">
          <figure :title="item.fileTitle">
            <img
              :src="getImage(item.file)"
              :alt="item.fileAlt"
              loading="lazy"
            >
            <figcaption v-if="item.fileCaption" v-html="generate(item.fileCaption, 'minimal')" />
          </figure>
        </a>
      </template>
      <template v-else>
        <figure :title="item.fileTitle">
          <img
            :src="getImage(item.file)"
            :alt="item.fileAlt"
            loading="lazy"
          >
          <figcaption v-if="item.fileCaption" v-html="generate(item.fileCaption, 'minimal')" />
        </figure>
      </template>
    </template>
  </div>
</template>

<script>
import bbcodeHTML from '~/marketplace-front-core/config/bbcodeHTML'
import lazyVideo from '~/marketplace-front-core/utils/lazyVideo'
import playButton from '~/marketplace-front-core/assets/generate-icons/icons/play-button.svg?inline'

export default {
  components: { playButton },
  props: {
    item: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      playing: false
    }
  },
  created () {
    this.webp = this.isWebpSupported()
    if (this.item && this.item.file && this.item.file.isVideo) {
      this.playing = this.item.fileAutoplay
    }
  },
  mounted () {
    // lazyVideo()
    this.$nextTick(() => {
      lazyVideo()
    })
    if (this.item && this.item.file && this.item.file.isVideo) {
      this.$refs.video.addEventListener('playing', () => this.changePlay(true))
      this.$refs.video.addEventListener('pause', () => this.changePlay(false))
    }
  },
  beforeDestroy () {
    if (this.$refs.video) {
      this.$refs.video.removeEventListener('playing', () => this.changePlay(true))
      this.$refs.video.removeEventListener('pause', () => this.changePlay(false))
    }
  },
  methods: {
    generate (content, type) {
      return bbcodeHTML(content, type)
    },
    getImage (file) {
      const image = this.getImageBySize(file, 'w2000')
      if (this.webp) {
        return image.src
      } else {
        return image.webpFallback || image.src
      }
    },
    isWebpSupported () {
      return new Promise((resolve) => {
        const image = new Image()
        image.onerror = () => resolve(false)
        image.onload = () => resolve(image.width === 1)
        image.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA='
      }).catch(() => false)
    },
    play () {
      this.$refs.video.play()
    },
    pause () {
      this.$refs.video.pause()
    },
    changePlay (value) {
      this.playing = value
    }
  }
}
</script>
